Ctrl.$inject = ['$scope', '$state', 'PortalApi', 'Notification','$translate', 'Analytics', '$rootScope', 'Localization'];

function Ctrl($scope, $state, PortalApi, Notification,$translate, Analytics, $rootScope, Localization) {
    $scope.recPassForm = {};
    $scope.preLoader = false;
    $scope.attempt = 0;

    $scope.init = function () {
        $scope.remLoginForm = {
            phone: '',
            captcha: ''
        };
    };

    if($rootScope.useFrame && $state.current.data.iframe == false){
        document.body.classList.remove('bodyContainer');
        $state.go('pages.error404');
        $rootScope.useFrame = false;
    }

    $scope.sendLogin = function () {
        $scope.preLoader = true;

        PortalApi.loginReminder($scope.remLoginForm).then(
            function (response) {

                if (response.status !== 'ok') {
                    Localization.notifyTemplate('error', 'NOTIFICATION.LOGIN_RECOVER.NOT_FOUND', 5, true);
                }
                $scope.attempt++;

                Analytics.trackEvent(
                    'Восстановление логина',
                    'Успешно',
                    'Подтверждение кода' + $scope.attempt + 'попытка'
                );
                Analytics.pageView();

                Localization.notifyTemplate('info', 'NOTIFICATION.LOGIN_RECOVER.SEND', 5, true);

                $state.go('pages.login');
            },
            function () {

                $scope.attempt++;

                Analytics.trackEvent(
                    'Востановление логина',
                    'Не успешно',
                    'Подтверждение кода' +  $scope.attempt +'попытка'
                );
                Analytics.pageView();

                Localization.notifyTemplate('error', 'NOTIFICATION.LOGIN_RECOVER.SEND_ERROR', 5, true);
            }
        ).finally(function () {
            $scope.preLoader = false;
        });
    };

    $scope.init();
}

module.exports = Ctrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/loginReminder/controllers/loginReminder.controller.js
 ** module id = 266
 ** module chunks = 1
 **/